import { Component, COMPONENT_TYPE, INPUT_COMPONENT_TYPE } from '@abiglobalhealth/go-types'

import { useGetComponent } from '@/hooks/useGetComponent'
import { useModule } from '@/hooks/useModule'
import { useStep } from '@/hooks/useStep'

export interface ComponentsLayoutProps {
  componentsOrder: string[]
  components: Record<string, Component>
}

const SPACE_COMPONENTS = [COMPONENT_TYPE.TEXT, COMPONENT_TYPE.CHECKBOX_GROUP, COMPONENT_TYPE.BUTTON]

export const ComponentsLayout = ({ componentsOrder, components }: ComponentsLayoutProps) => {
  const { currentStep } = useStep()
  const { currentModule } = useModule()
  const { getComponent } = useGetComponent()

  let tabIndex = 0

  return (
    <div className="flex flex-col" data-testid="components-layout-container">
      {componentsOrder.map((componentId) => {
        const component = components[componentId]

        if (!component) throw new Error(`Component ${componentId} not found in step ${currentStep?.id} and module ${currentModule?.id}`)

        const Component = getComponent(component)

        if (!Component) return null

        switch (component.componentType) {
          case COMPONENT_TYPE.COUNTRY_SELECT:
            tabIndex += 2
            break
          case COMPONENT_TYPE.ROW:
            tabIndex += Object.keys(component.components).length
            break
          case COMPONENT_TYPE.CHECKBOX_GROUP:
          case COMPONENT_TYPE.RADIO_GROUP:
          case COMPONENT_TYPE.SURVEY_CHOICES:
            tabIndex += Object.keys(component.options).length
            break
          case COMPONENT_TYPE.BUTTON:
          case COMPONENT_TYPE.INPUT:
          case COMPONENT_TYPE.SELECT:
          case COMPONENT_TYPE.PHONE_NUMBER:
            tabIndex++
            break
        }
        const isCheckbox = component.componentType === COMPONENT_TYPE.INPUT && component.type === INPUT_COMPONENT_TYPE.CHECKBOX
        const padding = SPACE_COMPONENTS.includes(component.componentType) || isCheckbox ? 'pb-6' : ''

        return (
          <div key={`${currentStep?.id}-${component.id}`} className={`animate-fade-in ${padding}`} data-testid={`component-${component.id}`}>
            <Component {...component} tabIndex={tabIndex} />
          </div>
        )
      })}
    </div>
  )
}
